import React from 'react'
import { CircleHelp } from 'lucide-react'

import { DistanceMetrics } from 'src/types'

import { SelectCurrencyInput } from 'src/features/SelectCurrencyInput'
import { TooltipWrapper } from 'src/components/Tooltip'

import { useUserInfoSettings } from 'src/features/UserCurrency/useUserInfoSettings'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'src/components/shadcn/select'
import { DISTANCE_METRICS } from './constants'

export const UserInfoSettings = (): JSX.Element => {
  const {
    locale,
    handleDistanceMetricChange,
    distanceMetric,
    actualCurrencyDate,
  } = useUserInfoSettings()

  return (
    <div className="mt-6 space-y-4 max-w-[250px]">
      <div className="flex justify-items-start items-center gap-1.5 relative">
        <span className="text-md font-medium w-[72%]">{locale.currency}</span>
        <SelectCurrencyInput />
        <div className="absolute -right-[40px] cursor-pointer">
          <TooltipWrapper text={`${locale.actualData}: ${actualCurrencyDate}`}>
            <CircleHelp className="hover:opacity-75 duration-200 transition-opacity" />
          </TooltipWrapper>
        </div>
      </div>

      <div className="flex justify-items-start items-center gap-1.5">
        <span className="text-lg font-medium w-[72%]">
          {locale.distanceMetric}
        </span>
        <Select
          onValueChange={handleDistanceMetricChange}
          value={distanceMetric}
        >
          <SelectTrigger>
            <SelectValue>{distanceMetric}</SelectValue>
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              {DISTANCE_METRICS.map(metric => {
                return (
                  <SelectItem
                    className="lowercase"
                    key={metric}
                    value={DistanceMetrics[metric]}
                  >
                    {metric}
                  </SelectItem>
                )
              })}
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}
